import { FC } from "react";
import styled from "styled-components";

import Text from "@/components/Text";

const Box = styled.div`
  background: ${({ theme }) => theme.colors.grayscaleLight};
  border-radius: 4px;
  padding: 16px;
`;

const Label = styled(Text)`
  margin-bottom: 8px;
`;

interface Props {
  projectTitle: string;
}

const TestingProjectName: FC<Props> = ({ projectTitle }) => {
  return (
    <Box>
      <Label $type="smallHeadline" $color="gray">
        Project Name
      </Label>
      <Text $type="button">{projectTitle}</Text>
    </Box>
  );
};

export default TestingProjectName;
